import Big from 'big.js'
import btoa from 'btoa'

class SharedUtilities {
    static urlParamExists(param) {
        const urlParams = new URLSearchParams(window.location.search)

        return urlParams.has(param)
    }

    static getUrlParam(param) {
        const urlParams = new URLSearchParams(window.location.search)

        return urlParams.get(param)
    }

    static getBase64JsonUrlParam(param) {
        const urlParams = new URLSearchParams(window.location.search)

        if (urlParams.has(param)) {
            try {
                return JSON.parse(atob(urlParams.get(param)))

            } catch (err) {
                throw new Error('The link you have followed is not valid. Please request a new link.')
            }
        }

        return null
    }

    static createBase64Json(value) {
        try {
            return btoa(JSON.stringify(value))

        } catch (err) {
            throw new Error('Unable to create URL param')
        }
    }

    static requireValue(name, value) {
        if (value === undefined || value === null || value === '') {
            throw new Error(`${name} is required`)
        }
    }

    static requireValues(required) {
        for (let name in required) {
            this.requireValue(name, required[name])
        }
    }

    static cartQualifiesForFreeShipping(cart, service) {
        const { freeShippingEnabled, freeShippingMinSubtotal, freeShippingExcludes, freeShippingMethods } = cart

        // check that the feature is enabled
        if (!freeShippingEnabled) {
            return false
        }

        // check that there's a shipping method chosen
        if (!service) {
            return false
        }

        // check that order subtotal meets mininum
        if (freeShippingMinSubtotal && Big(cart.subtotal).lt(freeShippingMinSubtotal)) {
            return false
        }

        // check that all items qualifiy for free shipping
        const excludes = freeShippingExcludes.split(',').map(exclude => exclude.trim())

        if (cart.contents.some(item => excludes.includes(item.upc))) {
            return false
        }

        // check if selected method qualifies for free shipping
        const methods = freeShippingMethods.split(',').map(method => method.trim())

        if (!methods.includes(service)) {
            return false
        }

        return true
    }

    static async base64EncodeFile(file) {
        return await new Promise((resolve, reject) => {
            const reader = new FileReader()

            reader.readAsDataURL(file)

            reader.onerror = reject

            reader.onload = function () {
                resolve(reader.result.split(',')[1])
            }
        })
    }
}

if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
    window.debug = { ...window.debug, SharedUtilities }
}

export default SharedUtilities
